import { mapState, mapActions } from 'vuex'
import EncashmentNotification from '../encashment-notification/encashment-notification.vue'
import EncashmentHistory from '../encashment-history/encashment-history.vue'
import CreateEncashmentModal from '@/components/modals/create-encashment-modal/create-encashment-modal.vue'
import ConfirmEncashmentModal from '@/components/modals/confirm-encashment-modal/confirm-encashment-modal.vue'

export default {
  name: 'CashStats',
  components: {
    EncashmentNotification,
    EncashmentHistory,
    CreateEncashmentModal,
    ConfirmEncashmentModal
  },
  computed: {
    ...mapState({
      cashbox: state => state.orders.cashbox,
      encashmentHistory: state => state.encashment.history
    }),
    cashPayment() {
      return this.$store.state.orders.orderPayments ?
        this.$store.state.orders.cashbox.cash_in_stock : 0
    }
  },
  methods: {
    ...mapActions({
      createEncashment: 'encashment/createEncashment',
      cancelLastEncashment: 'encashment/cancelLastEncashment'
    }),
    onAddEncashment() {
      this.$nextTick(() => {
        this.$refs['create-encashment-modal'].show()
      })
    },
    async onCreateEncashment({ amount }) {
      await this.createEncashment(amount)
      this.$refs['confirm-encashment-modal'].show()
    },
    onCancelEncashment() {
      this.isWasCancelEncashment = true
      this.cancelLastEncashment()
      .catch(() => {
        this.isWasCancelEncashment = false
        this.$refs['confirm-encashment-modal'].show()
      })      
    },
    onConfirmEncashmentHide() {
      if (!this.isWasCancelEncashment) {
        this.$refs['create-encashment-modal'].hide()
      } else {
        this.isWasCancelEncashment = false
      }
    }
  }
}